import React, { FC, useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  NotificationButtons,
  NotificationMessages,
  useTrackNotificationInteraction,
} from '../../utils/hooks/bi/useTrackNotificationInteraction';
import { Notification } from '../common/Notification';
import { NotificationTheme } from '../common/Notification/Notification.types';
import {
  INotificationComponentOuter,
  INotificationWithFileId,
} from './notifications.types';

export const deleteSuccessNotification = ({
  fileId,
}: INotificationWithFileId) => {
  const DeleteSuccessNotificationComponent: FC<INotificationComponentOuter> = ({
    onClose,
  }) => {
    const {
      trackErrorClick,
      trackErrorShown,
    } = useTrackNotificationInteraction();

    const handleCloseClick = useCallback(() => {
      trackErrorClick({
        errorMessage: NotificationMessages.DeleteSuccess,
        fileId,
        buttonName: NotificationButtons.Close,
      });
    }, [trackErrorClick, fileId]);

    useEffect(() => {
      trackErrorShown({
        errorMessage: NotificationMessages.DeleteSuccess,
        fileId,
      });
    }, [trackErrorShown, fileId]);

    return (
      <Notification
        dataHook="delete-success-notification"
        theme={NotificationTheme.Success}
        label={
          <FormattedMessage id="video-maker-home.notification.success.delete" />
        }
        onCloseButtonClick={handleCloseClick}
        onClose={onClose}
      />
    );
  };

  return DeleteSuccessNotificationComponent;
};
